// export const getSMSFrom = () => {
//   let type = {}
//   type.SMS_CODE_TYPE_REG = 1            // 注册时获取验证码
//   type.SMS_CODE_TYPE_MOBILE_LOGIN = 2  // 登录时获取验证码
//   type.SMS_CODE_TYPE_UPDATE_PWD = 3   // 更新密码获取验证码
//   return type
// }

export const getSMSFrom = {
  SMS_CODE_TYPE_REG: 1, // 注册时获取验证码
  SMS_CODE_TYPE_MOBILE_LOGIN: 2, // 登录时获取验证码
  SMS_CODE_TYPE_UPDATE_PWD: 3, // 更新密码获取验证码
  SMS_CODE_TYPE_CHECK_PHONE: 4, // 验证手机号
  SMS_CODE_TYPE_WXCHANGE_ACCOUNT: 5,// 微信登录修改账号（关联微信）
  UPDATE_USER: 7, // 修改账号(新加)
  SMS_CODE_TYPE_WXBINDANDCREATE_ACCOUNT: "",// 合并与创建时发送的状态
  SMS_CODE_TYPE_OLD_PHONE: 40001, // 验证旧手机号
  SMS_CODE_TYPE_NEW_PHONE: 40002, // 验证新手机号
  SCAN_MODEL: "model",// 扫描二维码保存sessionStorage字段
  SCAN_IDENTITY: "identity",// 扫描二维码保存sessionStorage字段
}
